var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"mb-7",attrs:{"fluid":""}},[_c('v-row',{staticClass:"mt-0 default-gutter"},[(_vm.guideline.id)?_c('v-col',{staticClass:"pt-0 pb-0 scroll-container"},[_c('PostContainer',{attrs:{"section":"Coverage Guidelines","post":_vm.guideline}})],1):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }